/**
 * Les dates d'un JOUR (sans heure) — une seule façon de les écrire et de les lire
 * (lot « Dates », 2026-10-07).
 *
 * L'application affiche toujours `jj/mm/aaaa`, quel que soit le réglage du poste :
 * un Windows en « Français (Canada) » écrit `aaaa-mm-jj`, un poste en anglais
 * américain `mm/jj/aaaa` (et le 03/04 devient ambigu). Le serveur, lui, échange
 * toujours `aaaa-mm-jj`.
 *
 * ⚠️ Pour un INSTANT (un horodatage « envoyé le », « déposé le »), ce n'est pas ici :
 * il faut le convertir dans le fuseau de Paris (`toLocaleDateString('fr-FR', …)`).
 */

/**
 * Date affichable, `jj/mm/aaaa`.
 *
 * ⚠️ La date arrive du serveur en ISO (`2007-01-04T00:00:00.000Z`) : PostgreSQL rend
 * un DATE et le pilote en fait un instant à minuit UTC. La convertir par `new Date()`
 * puis `toLocaleDateString` ferait dépendre le jour affiché du fuseau du poste — à
 * l'ouest de Greenwich, tout le monde naîtrait la veille. On découpe donc la chaîne,
 * sans jamais construire d'instant.
 */
export function dateFr(valeur) {
    if (!valeur) return '';
    const iso = String(valeur).slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return String(valeur);
    const [a, m, j] = iso.split('-');
    return `${j}/${m}/${a}`;
}

/** Le jour existe-t-il vraiment (pas de 31/02, pas de mois 13) ? */
function jourExiste(a, m, j) {
    if (a < 1000 || m < 1 || m > 12 || j < 1) return false;
    const d = new Date(Date.UTC(a, m - 1, j));
    return d.getUTCFullYear() === a && d.getUTCMonth() === m - 1 && d.getUTCDate() === j;
}

const deux = (n) => String(n).padStart(2, '0');

/**
 * Lit une date saisie et renvoie `aaaa-mm-jj`, ou null si elle n'est pas une date.
 * Accepte `7/10/2026`, `07/10/2026`, `07-10-2026`, `07.10.2026`, `07102026`
 * et l'ISO `2026-10-07` (un collage depuis un tableur, un banc).
 */
export function lireDateSaisie(texte) {
    const t = String(texte || '').trim();
    let a, m, j;
    let r = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (r) [a, m, j] = [r[1], r[2], r[3]];
    else if ((r = t.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/))) [j, m, a] = [r[1], r[2], r[3]];
    else if ((r = t.match(/^(\d{2})(\d{2})(\d{4})$/))) [j, m, a] = [r[1], r[2], r[3]];
    else return null;
    a = Number(a); m = Number(m); j = Number(j);
    return jourExiste(a, m, j) ? `${a}-${deux(m)}-${deux(j)}` : null;
}
